export default __webpack_public_path__ + "static/media/notification.0e747a69.svg";